export default "<div #RTE class=\"ql-editore\"></div>"